module.exports = __webpack_public_path__ + "static/img/logo03.a68585a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo03.png
// module id = O8XZ
// module chunks = 0